import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Compass } from "lucide-react";
import { JHALA_GLOBAL_CSS, TopStrip, Header, Footer, Reveal, TagChip } from "components/jhala/Layout.js";

export default function NotFoundPage() {
  return (
    <div style={{ fontFamily: "'Inter', sans-serif", background: "#F6F4EE", color: "#0A0F1E" }}>
      <style>{JHALA_GLOBAL_CSS}</style>
      <TopStrip />
      <Header />

      <section style={{ background: "#0A0F1E", color: "#F6F4EE", padding: "120px 24px", position: "relative", overflow: "hidden", textAlign: "center" }}>
        <div style={{ position: "absolute", inset: 0, backgroundImage: "linear-gradient(#23304A 1px, transparent 1px), linear-gradient(90deg, #23304A 1px, transparent 1px)", backgroundSize: "48px 48px", opacity: 0.2, maskImage: "radial-gradient(ellipse at 50% 30%, black, transparent 70%)" }} />
        <div style={{ maxWidth: 560, margin: "0 auto", position: "relative" }}>
          <Reveal>
            <div style={{ marginBottom: 20 }}>
              <TagChip tone="signal">$ curl jhalatech.com{typeof window !== "undefined" ? window.location.pathname : ""} --status 404</TagChip>
            </div>
            <Compass size={32} style={{ color: "#4CE0B3", marginBottom: 16 }} />
            <h1 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "clamp(48px, 8vw, 96px)", lineHeight: 1, margin: "0 0 16px" }}>
              404
            </h1>
            <p style={{ fontSize: 16, color: "#B8BFCF", lineHeight: 1.65, marginBottom: 32 }}>
              This page doesn't exist — maybe it moved, maybe it never did. Let's get you back on track.
            </p>
            <Link to="/" className="cta-btn" style={{ background: "#4CE0B3", color: "#0A0F1E", border: "none", padding: "13px 24px", borderRadius: 4, fontWeight: 600, fontSize: 14, cursor: "pointer", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 8 }}>
              Back to Home <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>

      <Footer />
    </div>
  );
}
